import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelDynamic as _vModelDynamic, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17dc59c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-right" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "grid grid-cols-2 gap-4"
}
const _hoisted_4 = { class: "surname text-input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Cognome", -1))
const _hoisted_6 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_7 = { class: "name text-input" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nome", -1))
const _hoisted_9 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_10 = { class: "phone text-input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Numero di telefono", -1))
const _hoisted_12 = { class: "tax-code text-input" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tax" }, "Codice fiscale", -1))
const _hoisted_14 = { class: "agency text-input col-span-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Agenzia", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 1,
  class: "permissions mt-6"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold inline-block" }, "Permessi", -1))
const _hoisted_19 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_20 = { class: "email text-input" }
const _hoisted_21 = { class: "select" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "role" }, "Livello accesso piattaforma", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 0,
  class: "select-description self-center -mb-6"
}
const _hoisted_25 = {
  key: 1,
  class: "select-description self-center -mb-6"
}
const _hoisted_26 = {
  key: 2,
  class: "select-description self-center -mb-6"
}
const _hoisted_27 = {
  key: 3,
  class: "select-description self-center -mb-6"
}
const _hoisted_28 = {
  key: 2,
  class: "credentials mt-6"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold inline-block pb-4" }, "Credenziali app", -1))
const _hoisted_30 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 pb-4"
}
const _hoisted_31 = { class: "surname text-input" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "isEnabled" }, "Abilita accesso", -1))
const _hoisted_33 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_34 = { class: "email text-input" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_36 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_37 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_38 = { class: "password text-input relative" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1))
const _hoisted_40 = ["type"]
const _hoisted_41 = { class: "see-password cursor-pointer text-right float-right max-w-fit right-4 absolute top-10" }
const _hoisted_42 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_43 = {
  key: 1,
  class: "font-light text-red-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, null, {
    h1: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
    ]),
    h2: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.subtitle), 1)
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_PrimaryButton, {
          class: "button bg-white text-gray-600 undo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Annulla")
          ]),
          _: 1
        }),
        _createVNode(_component_PrimaryButton, {
          class: "button bg-primary-900 text-white",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mainAction()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.actionTitle), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.mode != _ctx.EditUserModalDialogMode.editEmployeeCredentials)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["bg-white border-red-400", { border: _ctx.v$.user.surname.$error }]),
                  id: "surname",
                  type: "text",
                  placeholder: "Cognome",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.surname) = $event)),
                  onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.user.surname.$touch && _ctx.v$.user.surname.$touch(...args)))
                }, null, 34), [
                  [_vModelText, _ctx.user.surname]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.user.surname.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_6, "È necessario inserire il cognome del dipendente."))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["bg-white border-red-400", { border: _ctx.v$.user.name.$error }]),
                  id: "name",
                  type: "text",
                  placeholder: "Nome",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.name) = $event)),
                  onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.user.name.$touch && _ctx.v$.user.name.$touch(...args)))
                }, null, 34), [
                  [_vModelText, _ctx.user.name]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.user.name.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_9, "È necessario inserire il nome del dipendente."))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  class: "bg-white col-span-2",
                  id: "phone",
                  type: "text",
                  placeholder: "Numero di telefono del dipendente",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.phone) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.user.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  class: "bg-white col-span-2",
                  id: "tax",
                  type: "text",
                  placeholder: "Codice fiscale",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.taxCode) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.user.taxCode]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("select", {
                  class: "bg-white",
                  id: "working-site",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.agency) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agencies, (agency) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: agency.value
                    }, _toDisplayString(agency.name), 9, _hoisted_16))
                  }), 256))
                ], 512), [
                  [_vModelSelect, _ctx.user.agency]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.mode == _ctx.EditUserModalDialogMode.addUser || _ctx.mode == _ctx.EditUserModalDialogMode.editUser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _withDirectives(_createElementVNode("select", {
                      class: "input bg-white border-red-400",
                      id: "role",
                      name: "role",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.role) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableUserRoles, (kv) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: kv[0]
                        }, _toDisplayString(kv[1]), 9, _hoisted_23))
                      }), 256))
                    ], 512), [
                      [_vModelSelect, _ctx.user.role]
                    ])
                  ])
                ]),
                (_ctx.user.role == _ctx.UserRole.GUEST)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Il ruolo 'ospite' non ha permessi di accedere e gestire dati di questa piattaforma"))
                  : _createCommentVNode("", true),
                (_ctx.user.role == _ctx.UserRole.WORKER)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Il ruolo 'dipendente' ha il permesso di accesso su questa piattaforma e può gestire i dati relativi alle timbrature"))
                  : _createCommentVNode("", true),
                (_ctx.user.role == _ctx.UserRole.ADMIN)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Il ruolo 'amministratore' ha il permesso di accedere su questa piattaforma e può gestire i dati dipendenti, eventi, strumenti, timbrature e cantieri."))
                  : _createCommentVNode("", true),
                (_ctx.user.role == _ctx.UserRole.SUPER_ADMIN)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Il ruolo 'super amministratore' ha tutti i permessi di gestione di questa piattaforma"))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.mode == _ctx.EditUserModalDialogMode.addUser || _ctx.mode == _ctx.EditUserModalDialogMode.addEmployee || _ctx.mode == _ctx.EditUserModalDialogMode.editUser || _ctx.mode == _ctx.EditUserModalDialogMode.editEmployeeCredentials)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              (_ctx.mode == _ctx.EditUserModalDialogMode.addUser || _ctx.mode == _ctx.EditUserModalDialogMode.editUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createVNode(_component_Toggle, {
                        class: "inline-block self-center",
                        name: "isEnabled",
                        modelValue: _ctx.user.isEnabled,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.user.isEnabled) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["bg-white border-red-400", { border: _ctx.v$.user.email.$error }]),
                    id: "email",
                    name: "email",
                    type: "text",
                    placeholder: "email@essegroup.org",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.user.email) = $event)),
                    onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.v$.user.email.$touch && _ctx.v$.user.email.$touch(...args)))
                  }, null, 34), [
                    [_vModelText, _ctx.user.email]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.user.email.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "errors",
                      key: error.$uid
                    }, [
                      (error.$validator == 'email')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_36, "L'email inserita non è valida."))
                        : _createCommentVNode("", true),
                      (error.$validator == 'required')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_37, "È necessario inserire l'email del dipendente."))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["bg-white border-red-400 focus:bg-white", { border: _ctx.v$.user.password.$error }]),
                    id: "password",
                    type: _ctx.passwordFieldType,
                    placeholder: "*********",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.user.password) = $event)),
                    onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.v$.user.password.$touch && _ctx.v$.user.password.$touch(...args)))
                  }, null, 42, _hoisted_40), [
                    [_vModelDynamic, _ctx.user.password]
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    (_ctx.isSeePassword)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          class: "h-5",
                          icon: ['fas', 'eye-slash'],
                          onClick: _ctx.seeHidePassword
                        }, null, 8, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 1,
                          class: "h-5",
                          icon: ['fas', 'eye'],
                          onClick: _ctx.seeHidePassword
                        }, null, 8, ["onClick"]))
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.user.password.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "errors",
                      key: error.$uid
                    }, [
                      (error.$validator == 'required')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_42, "È necessario inserire la password del dipendente."))
                        : _createCommentVNode("", true),
                      (error.$validator == 'minLength')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_43, "La password deve essere lunga almeno 6 caratteri."))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            message: "Salvataggio..."
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}